import { Component, OnInit } from '@angular/core';
import { DataService } from '../../services/data.service';
import { BusinesLogicService } from '../../services/business-logic.service';
import { UtilsService } from '../../services/utils.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-phone',
  templateUrl: './phone.component.html',
  styleUrls: ['./phone.component.css']
})
export class PhoneComponent implements OnInit {

  public enableRecallButton: boolean = false;
  public enableCallButton: boolean = false;
  public enableRecallSupervisor = false;

  private destroy$ = new Subject();

  constructor(public _data: DataService,
    private _utils: UtilsService,
    private _blogic: BusinesLogicService) { }

  ngOnInit() {
    this._updateTurn(this._data.turn);
    this._data.turnUpdate
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: object) => {
          this._updateTurn(response);
        }
      );

    this._selectedUpdateTurn(this._data.selectedTurn);
    this._data.selectedTurnUpdate
    .pipe(takeUntil(this.destroy$))
    .subscribe(
      (response: object) => {
        this._selectedUpdateTurn(response);
      }
    );
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public getTicket(): void {
    let params: object = {
      clientname: '',
      prekind_id: this._data.configuration['phoneKindId'],
      printed: true,
      clientid: ''
    };

    this._blogic.getTicket(params)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: any) => {
          let data = response;
          this.callTurn(data["id"], data["queue_id"]);
        }
      );
  }

  private callTurn(id: number, queue: number) {

    let params: object = [];

    params = {
      desk_id: this._data.session["desk"],
      turn_id: id,
      queue_id: queue,
      action: this._data.configuration["actionToCall"],
      deskuser: this._data.session["username"],
      deskoperator: this._data.session["operator"]
    };

    this._blogic.setTurn(params)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: any) => {
          this._data.actionContainer = 0;
          if (response["turn_id"] == "-1") {
            this._data.closeTurn();
          } else {
            this._data.turn = response;
          }
        }
      );
  }


  /* When the turn information change */
  private _updateTurn(turn: object): void {
    if (turn == null) {
      this.enableRecallButton = false;
    } else {
      this.enableRecallButton = true;
    }
  }

  /* When the turn information change */
  private _selectedUpdateTurn(selectedTurn: object): void {
    if (selectedTurn != null && selectedTurn["type"] == 'inWait') {
      this.enableCallButton = true;
    } else {
      this.enableCallButton = false;
    }

    if (selectedTurn != null
      && selectedTurn["type"] == 'inAttention'
      && this._data.configuration["activeSupervisor"]) {
      this.enableRecallSupervisor = true;
    } else {
      this.enableRecallSupervisor = false;
    }

  }

}
